import { Skeleton } from '@/components/ui/skeleton'

const RewardsSkeleton = () => {
  return (
    <div className="w-full md:mt-6">
      {/* Points balance row */}
      <div className="flex flex-row items-center justify-between w-full">
        <Skeleton className="h-4 w-32" />
        <div className="flex flex-row items-center gap-1">
          <Skeleton className="h-7 w-14" />
          <Skeleton className="h-6 w-6 rounded-full" />
        </div>
      </div>

      {/* Divider (desktop only) */}
      <div className="border-b-dGray-200 border-b-[1px] my-6 hidden md:block" />

      {/* Progress bar skeleton (desktop only) */}
      <div className="hidden md:block mt-6">
        <Skeleton className="h-4 w-full" />
      </div>
    </div>
  )
}

export default RewardsSkeleton
